import PropTypes from 'prop-types';

import ImageComponent from '../../ImageComponent';
import { getFromLocalStorageAndDecrypt } from '../../../WebChatEncryptDecrypt';
import { cn } from '../../../../../ui/lib/utils';
import { getContactName } from '../contactHelpers';
import styles from './index.module.scss';

/**
 * Round contact avatar: the photo, else initials (common rule 19), at a fixed size.
 *
 * @param {object} contact Contact returned by the contact APIs.
 * @param {'md'|'chip'|'sm'} size md for list rows, chip for composer chips, sm for selection chips.
 */
const ContactAvatar = ({ contact, size = 'md' }) => (
    <span className={cn(styles.avatar, styles[size])}>
        <ImageComponent
            chatType="chat"
            userToken={getFromLocalStorageAndDecrypt('token')}
            imageToken={contact.thumbImage || contact.image || ''}
            name={getContactName(contact)}
            hideClassNameStatus
        />
    </span>
);

ContactAvatar.propTypes = {
    contact: PropTypes.shape({
        image: PropTypes.string,
        thumbImage: PropTypes.string,
        displayName: PropTypes.string,
        nickName: PropTypes.string,
    }).isRequired,
    size: PropTypes.oneOf(['md', 'chip', 'sm']),
};

export default ContactAvatar;
